import { Component, computed, input } from '@angular/core';
import { MatMenuPanel, MatMenuTrigger } from '@angular/material/menu';
import { BadgeComponent } from '../badge';

import { SvgViewboxDirective } from '@exl-ng/mulo-core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'mulo-notify-bell',
  templateUrl: './notify-bell.component.html',
  styleUrls: ['./notify-bell.component.scss'],
  imports: [
    MatIconButton,
    MatMenuTrigger,
    MatIcon,
    SvgViewboxDirective,
    BadgeComponent,
  ],
})
export class NotifyBellComponent {
  readonly ariaLabel = input<string>();
  protected readonly ariaLabelDisplay = computed(
    () => this.ariaLabel() || `Notifications (${this.count()})`,
  );
  readonly triggerFor = input<MatMenuPanel>(undefined);
  readonly count = input(0);
}
